(function () {
  var HOME = typeof window.NuceryAdminGuardHome === 'string' ? window.NuceryAdminGuardHome : '/';

  function isShopifyStaff() {
    if (window.Shopify && (Shopify.designMode || Shopify.visualPreviewMode)) return true;
    return !!document.querySelector(
      '#shopify-admin-bar, #PBar, #preview-bar-iframe, [data-shopify="admin-bar"], .shopify-preview-bar'
    );
  }

  function isAdminUrl(href) {
    if (!href || href.charAt(0) === '#') return false;
    try {
      var url = new URL(href, window.location.origin);
      if (/admin\.shopify\.com$/i.test(url.hostname) || /admin\.shopify\.com/i.test(url.hostname)) {
        return true;
      }
      var path = url.pathname.toLowerCase();
      if (path === '/admin' || path.indexOf('/admin/') === 0) return true;
    } catch (err) {
      if (/\/admin(\/|$|\?)/i.test(href)) return true;
    }
    return false;
  }

  function redirectHome() {
    window.location.replace(HOME);
  }

  function guardPath() {
    if (isShopifyStaff()) return;
    var path = window.location.pathname.toLowerCase();
    if (path === '/admin' || path.indexOf('/admin/') === 0) {
      redirectHome();
    }
  }

  document.addEventListener(
    'click',
    function (evt) {
      if (isShopifyStaff()) return;
      var link = evt.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!isAdminUrl(href)) return;
      evt.preventDefault();
      evt.stopPropagation();
      redirectHome();
    },
    true
  );

  guardPath();
})();
